module.exports = __webpack_public_path__ + "static/media/logo-camarapontonovo.46aba9a0.png";